import { Link } from "react-router-dom";

const Home = () => {
    const steps = [
        {
            id: "01",
            title: "Descubri eventos",
            description:
                "Explora recitales, fiestas, shows y experiencias cerca tuyo en segundos.",
        },
        {
            id: "02",
            title: "Compras seguras",
            description:
                "Paga tus entradas de forma rapida y recibi tus tickets digitales al instante.",
        },
        {
            id: "03",
            title: "Ingresa sin vueltas",
            description:
                "Presenta tu QR desde el celular y entra al evento sin impresiones ni demoras.",
        },
    ];

    const producerBenefits = [
        "Panel para crear y gestionar eventos en minutos.",
        "Control de ventas, stock y validacion de ingresos en tiempo real.",
        "Difusion y visibilidad frente a miles de personas cada semana.",
    ];

    return (
        <main className="relative overflow-hidden bg-zinc-950 text-white">
            <section className="relative isolate overflow-hidden pb-16 pt-28 sm:pt-32 lg:pt-36">
                <div
                    className="pointer-events-none absolute inset-0 opacity-80"
                    aria-hidden="true"
                    style={{
                        background:
                            "radial-gradient(circle at 15% 15%, rgba(225, 29, 72, 0.30), transparent 34%), radial-gradient(circle at 92% 3%, rgba(190, 24, 93, 0.24), transparent 32%), radial-gradient(circle at 86% 80%, rgba(244, 114, 182, 0.14), transparent 36%)",
                    }}
                />

                <div className="relative mx-auto flex min-h-[70vh] w-full max-w-6xl items-center justify-start px-4 sm:min-h-[74vh] sm:px-6">
                    <div className="home-reveal w-full max-w-3xl text-left">
                        <span className="inline-flex rounded-full border border-rose-300/45 bg-rose-400/15 px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-rose-200">
                            Plataforma oficial de tickets
                        </span>
                        <h1 className="mr-auto mt-6 max-w-3xl text-4xl font-black leading-tight text-white sm:text-5xl lg:text-6xl">
                            Tu proxima salida empieza aca{" "}
                            <span className="text-rose-400">sin vueltas</span>
                        </h1>
                        <p className="mr-auto mt-6 max-w-2xl text-lg leading-relaxed text-zinc-200">
                            Somos tu puerta de entrada a conciertos, fiestas y experiencias unicas.
                            Compra facil, acceso rapido y todo desde tu celular.
                        </p>
                        <div className="mt-8 flex flex-wrap justify-start gap-3">
                            <Link
                                to="/"
                                className="inline-flex rounded-xl bg-rose-600 px-6 py-3 text-sm font-bold uppercase tracking-[0.08em] text-white transition hover:scale-[1.02] hover:bg-rose-500"
                            >
                                Ver eventos
                            </Link>
                            <a
                                href="https://producer.passevent.site"
                                className="inline-flex rounded-xl border border-zinc-100/35 bg-zinc-100/8 px-6 py-3 text-sm font-semibold uppercase tracking-[0.08em] text-zinc-100 backdrop-blur-sm transition hover:scale-[1.02] hover:bg-zinc-100/15"
                            >
                                Soy productor
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-12 sm:py-14">
                <div className="mx-auto max-w-6xl px-4 sm:px-6">
                    <div className="home-reveal mb-8 max-w-2xl">
                        <p className="text-sm font-semibold uppercase tracking-[0.14em] text-rose-300">
                            Como funciona
                        </p>
                        <h2 className="mt-2 text-3xl font-black text-white sm:text-4xl">
                            Compra tu entrada en tres pasos
                        </h2>
                    </div>
                    <div className="grid gap-5 md:grid-cols-3">
                        {steps.map((step, index) => (
                            <article
                                key={step.id}
                                className="home-reveal group rounded-2xl border border-zinc-700 bg-zinc-900/70 p-6 shadow-[0_16px_35px_rgba(0,0,0,0.25)] transition hover:-translate-y-1"
                                style={{ animationDelay: `${320 + index * 100}ms` }}
                            >
                                <span className="inline-flex rounded-full bg-rose-600 px-3 py-1 text-xs font-semibold tracking-[0.1em] text-white">
                                    {step.id}
                                </span>
                                <h3 className="mt-4 text-2xl font-black text-white">{step.title}</h3>
                                <p className="mt-3 text-base leading-relaxed text-zinc-300">
                                    {step.description}
                                </p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <section className="relative py-14 sm:py-16">
                <div
                    className="pointer-events-none absolute inset-0 opacity-80"
                    aria-hidden="true"
                    style={{
                        background:
                            "radial-gradient(circle at 12% 20%, rgba(225, 29, 72, 0.18), transparent 35%), radial-gradient(circle at 85% 75%, rgba(190, 24, 93, 0.16), transparent 34%)",
                    }}
                />
                <div className="relative mx-auto grid max-w-6xl gap-8 px-4 sm:px-6 lg:grid-cols-[1.1fr_1fr] lg:items-center">
                    <div className="home-reveal">
                        <p className="text-sm font-semibold uppercase tracking-[0.14em] text-rose-300">
                            Herramientas para productores
                        </p>
                        <h2 className="mt-2 text-3xl font-black text-white sm:text-4xl">
                            Publica, vende y controla tus eventos desde un solo lugar
                        </h2>
                        <p className="mt-4 max-w-xl text-base leading-relaxed text-zinc-300">
                            Si organizas eventos, PassEvent te da estructura operativa para escalar:
                            menos trabajo manual, mas control y mejores resultados.
                        </p>
                    </div>
                    <div className="home-reveal space-y-3 rounded-2xl border border-zinc-700 bg-zinc-900/80 p-6 shadow-[0_16px_40px_rgba(0,0,0,0.35)] [animation-delay:150ms]">
                        {producerBenefits.map((benefit) => (
                            <p
                                key={benefit}
                                className="rounded-xl border border-zinc-700 bg-zinc-800/70 px-4 py-3 text-sm font-semibold text-zinc-200"
                            >
                                {benefit}
                            </p>
                        ))}
                        <a
                            href="https://producer.passevent.site"
                            className="mt-2 inline-flex rounded-xl bg-rose-600 px-5 py-3 text-sm font-semibold uppercase tracking-[0.08em] text-white transition hover:scale-[1.02] hover:bg-rose-500"
                        >
                            Empezar ahora
                        </a>
                    </div>
                </div>
            </section>

            <section className="py-10 sm:py-12">
                <div className="mx-auto max-w-6xl px-4 sm:px-6">
                    <div className="home-reveal rounded-2xl border border-rose-500/35 bg-zinc-900/75 p-7 shadow-[0_18px_35px_rgba(0,0,0,0.35)]">
                        <p className="text-sm font-semibold uppercase tracking-[0.14em] text-rose-300">
                            Asesoramiento para productores
                        </p>
                        <h2 className="mt-2 text-3xl font-black text-white sm:text-4xl">
                            Te acompanamos a lanzar y vender mejor
                        </h2>
                        <p className="mt-4 max-w-2xl text-zinc-300">
                            Si estas organizando un evento y necesitas ayuda con estrategia de
                            venta, configuracion o difusion, te asesoramos por WhatsApp.
                        </p>
                        <a
                            href="https://api.whatsapp.com/send?phone=5492355550176&text=Hola%20vengo%20de%20PassEvent%20y%20mi%20consulta%20es..."
                            className="mt-6 inline-flex rounded-xl bg-rose-600 px-6 py-3 text-sm font-bold uppercase tracking-[0.08em] text-white transition hover:scale-[1.02] hover:bg-rose-500"
                        >
                            Quiero asesoramiento
                        </a>
                    </div>
                </div>
            </section>

            <section className="pb-16 pt-4 sm:pb-20">
                <div className="mx-auto max-w-6xl px-4 sm:px-6">
                    <div className="home-reveal rounded-3xl bg-gradient-to-r from-zinc-950 via-zinc-900 to-rose-950 p-7 text-center shadow-[0_22px_45px_rgba(0,0,0,0.22)] sm:p-10">
                        <h2 className="text-3xl font-black text-white sm:text-4xl">
                            Tu proximo plan empieza hoy
                        </h2>
                        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-zinc-200">
                            Revisa la cartelera completa, guarda tus favoritos y asegura tu entrada
                            antes de que se agoten.
                        </p>
                        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
                            <Link
                                to="/"
                                className="inline-flex rounded-xl bg-rose-600 px-6 py-3 text-sm font-bold uppercase tracking-[0.08em] text-white transition hover:scale-[1.02] hover:bg-rose-500"
                            >
                                Ir a eventos
                            </Link>
                            <Link
                                to="/tickets"
                                className="inline-flex rounded-xl border border-zinc-100/35 bg-zinc-100/8 px-6 py-3 text-sm font-semibold uppercase tracking-[0.08em] text-zinc-100 transition hover:scale-[1.02] hover:bg-zinc-100/15"
                            >
                                Ver mis tickets
                            </Link>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Home;
